import { inject, Injectable } from '@angular/core';
import { NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';

import { DateFormatService } from '../date-format.service';

@Injectable({
  providedIn: 'root',
})
export class CustomNgbDateFormatter extends NgbDateParserFormatter {
  private readonly dateFormatService = inject(DateFormatService);

  parse(value: string): NgbDateStruct {
    return this.dateFormatService.ngbDateFromString(value);
  }

  format(date: NgbDateStruct): string {
    return this.dateFormatService.stringFromNgbDate(date);
  }
}
